import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedVideos from './components/FeaturedVideos';
import LatestArticles from './components/LatestArticles';

const websiteSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '蓝莓视频',
  url: 'https://lanmei.video',
  description: '蓝莓视频是水果视频聚合平台，提供与香蕉视频、蜜桃视频、西瓜视频、樱桃视频同类型的高清影视资源，免费在线观看全集不缓冲。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://lanmei.video/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <SEOHead
        title="蓝莓视频 - 香蕉视频蜜桃视频西瓜视频樱桃视频同类水果视频平台 | 高清免费在线观看全集不缓冲"
        description="蓝莓视频提供与香蕉视频蜜桃视频等热门水果视频平台同类型的高清影视资源，免费在线观看电视剧全集电影大全，不缓冲流畅播放，类似水果视频推荐。"
        keywords="蓝莓视频,香蕉视频,蜜桃视频,水果视频,西瓜视频,樱桃视频,免费在线观看,高清,全集,不缓冲,视频平台,类似推荐"
        canonicalUrl="https://lanmei.video"
        ogImage="https://readdy.ai/api/search-image?query=Blueberry%20video%20streaming%20platform%20branding%2C%20warm%20amber%20and%20coral%20gradients%2C%20cinematic%20movie%20atmosphere%2C%20modern%20minimalist%20design%2C%20streaming%20service%20identity&width=1200&height=630&seq=og-home-01&orientation=landscape"
      />
      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>

      <ScrollToTop />
      <Navbar />

      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedVideos />
        <LatestArticles />

        <section className="py-10 md:py-14 bg-background-100">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-6xl mx-auto text-center">
              <h2 className="text-xl md:text-2xl font-bold text-foreground-900 font-heading mb-3">
                为什么选择蓝莓视频？
              </h2>
              <p className="text-sm text-foreground-500 mb-8">
                与香蕉视频、蜜桃视频、西瓜视频、樱桃视频同类型平台中的佼佼者
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
                {[
                  { icon: 'ri-4k-line', title: '高清画质', desc: '支持4K超高清画质，带来影院级观影体验' },
                  { icon: 'ri-speed-line', title: '不缓冲流畅', desc: '全球CDN加速节点，观看视频告别卡顿缓冲' },
                  { icon: 'ri-global-line', title: '海量资源', desc: '电影电视剧综艺动漫纪录片全覆盖，总有你想看的' },
                  { icon: 'ri-shield-check-line', title: '安全可靠', desc: '严格内容审核，为全家提供安全健康的观影环境' },
                ].map((item) => (
                  <div key={item.title} className="p-5 bg-background-50 rounded-xl text-center">
                    <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center">
                      <i className={`${item.icon} text-xl text-primary-500`}></i>
                    </div>
                    <h4 className="text-sm font-semibold text-foreground-900 mb-1.5">{item.title}</h4>
                    <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-10 md:py-14">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-6xl mx-auto">
              <div className="bg-gradient-to-br from-primary-500 via-primary-600 to-accent-500 rounded-2xl p-8 md:p-12 text-center">
                <h2 className="text-2xl md:text-3xl font-bold text-background-50 font-heading mb-3">
                  立即开启你的观影之旅
                </h2>
                <p className="text-sm md:text-base text-background-200 mb-6 max-w-lg mx-auto">
                  蓝莓视频汇聚海量高清影视资源，免费在线观看，不缓冲流畅播放。加入我们，享受极致观影体验！
                </p>
                <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
                  <a
                    href="/category/dianshiju"
                    className="px-8 py-3 rounded-full bg-background-50 text-primary-600 font-medium text-sm hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    立即观看
                  </a>
                  <a
                    href="/about"
                    className="px-8 py-3 rounded-full border border-background-50/30 text-background-50 font-medium text-sm hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    了解更多
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}